import axios from "axios";
import { url, dispatchLoading, dispatchToast, dispatchError, catchHandler, elseHandler } from "../utils";
import { DashboardData } from "../Admin/Redux/Dashboard";

const locationUrl = url + "location";

export const ListLocation = (type, isDeleted) => async (dispatch) => {
  dispatchLoading(dispatch, "location", true);
  let noDiskCache = { noDiskCache: 1, timeStamp: `${new Date().getTime()}` };
  let isDeletedLocation = isDeleted !== undefined ? isDeleted : false;
  axios
    .get(locationUrl + "/list", { params: { type, isDeleted: isDeletedLocation, noDiskCache }, withCredentials: true })
    .then((result) => {
      if (result?.data?.success) {
        dispatch({ type: "LOCATION_LIST_SUCCESS", payload: { type: type === "PICKUP" ? "pickUpList" : "dropOffList", data: result?.data?.data } });
        dispatchError(dispatch, "location", undefined);
      } else elseHandler(dispatch, "location", result?.data);
      dispatchLoading(dispatch, "location", false);
    })
    .catch(catchHandler(dispatch, "location"));
};

export const AddLocation = (data, setIsModalOpen, setModalPurpose) => async (dispatch) => {
  dispatchLoading(dispatch, "location", true);
  axios
    .post(locationUrl + "/", data, { withCredentials: true })
    .then((result) => {
      if (result?.data?.success) {
        dispatch({
          type: "LOCATION_ADD_SUCCESS",
          payload: { type: data?.type === "PICKUP" ? "pickUpList" : "dropOffList", data: result?.data?.data },
        });
        dispatchToast(dispatch, "success", result?.data?.msg);
        dispatchError(dispatch, "location", undefined);
        setIsModalOpen(false);
        setModalPurpose(-1);
        dispatch(DashboardData());
      } else elseHandler(dispatch, "location", result?.data);
      dispatchLoading(dispatch, "location", false);
    })
    .catch(catchHandler(dispatch, "location"));
};

export const UpdateLocation = (_id, updates, setIsModalOpen, setModalPurpose) => async (dispatch) => {
  dispatchLoading(dispatch, "location", true);
  axios
    .put(
      locationUrl + "/",
      {
        locationId: _id,
        updates,
      },
      { withCredentials: true }
    )
    .then((result) => {
      if (result?.data?.success) {
        dispatchToast(dispatch, "success", result?.data?.msg);
        dispatchError(dispatch, "location", undefined);
        setIsModalOpen(false);
        setModalPurpose(-1);
        dispatch(ListLocation(updates?.type));
      } else elseHandler(dispatch, "location", result?.data);
      dispatchLoading(dispatch, "location", false);
    })
    .catch(catchHandler(dispatch, "location"));
};

export const DeleteLocation = (locationId, locationType) => async (dispatch) => {
  dispatchLoading(dispatch, "location", true);
  axios
    .delete(locationUrl + "/", { data: { locationId }, withCredentials: true })
    .then((result) => {
      if (result?.data?.success) {
        dispatch(ListLocation(locationType));
        dispatch(DashboardData());
        dispatchToast(dispatch, "success", result?.data?.msg);
        dispatchError(dispatch, "location", undefined);
      } else elseHandler(dispatch, "location", result?.data);
      dispatchLoading(dispatch, "location", false);
    })
    .catch(catchHandler(dispatch, "location"));
};

export const RestoreLocation = (locationId, locationType, setModal) => async (dispatch) => {
  dispatchLoading(dispatch, "location", true);
  axios
    .put(locationUrl + "/restore", { locationId }, { withCredentials: true })
    .then((result) => {
      if (result?.data?.success) {
        dispatch(ListLocation(locationType, true));
        dispatch(DashboardData());
        setModal(false)
        dispatchToast(dispatch, "success", result?.data?.msg);
        dispatchError(dispatch, "location", undefined);
      } else elseHandler(dispatch, "location", result?.data);
      dispatchLoading(dispatch, "location", false);
    })
    .catch(catchHandler(dispatch, "location"));
};
